<template>
  <div class="p-2">
    <submission-spinner v-if="showSpinner"></submission-spinner>
    <div v-else class="flex flex row">
      <div class="ml-4" style="word-break: break-word">
        <p
          class="mt-1 max-w-2xl text-xs font-semibold leading-5 text-darkpurple"
        >
          {{ message.userDisplay }}
          <a
            v-if="isAdmin"
            @click="remove"
            href="#"
            class="text-red-500 underline"
          >
            -  Remove - </a
          >
        </p>

        <vue-markdown :source="message_text" class="mt-1 prose text-gray-800"></vue-markdown>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "./Avatar";
import { mapGetters } from "vuex";
import SubmissionSpinner from "./SubmissionSpinner";
import ConfirmationModal from "./ConfirmationModal";
import VueMarkdown from "vue-markdown";

export default {
  name: "Message",
  // eslint-disable-next-line vue/no-unused-components
  components: { Avatar, SubmissionSpinner, ConfirmationModal, VueMarkdown },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {};
  },
  methods: {
    remove() {
      this.$emit("remove-message", this.message);
    }
  },
  computed: {
    ...mapGetters(["isAdmin", "deletedMessageID"]),
    showSpinner() {
      if (this.deletedMessageID === this.message.id) {
        return true;
      }
      return false;
    },
    message_text() {
      return this.message.body.replace(/(^|\s)(@[^\s]+)/gi, '$1<u>$2</u>');
    }
  }
};
</script>

<style scoped></style>
